var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-application',{attrs:{"multiple":"","app-types":_vm.appTypes,"label":_vm.$t('Visibility')},model:{value:(_vm.visibility),callback:function ($$v) {_vm.visibility=$$v},expression:"visibility"}})}
var staticRenderFns = []

export { render, staticRenderFns }